import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Layout_structure extends PureComponent {
  render() {
    return (
      <div className="row" id="layout_structure">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Layout Structure</h2>
              <p>
                The layout structure is the same for the record, search, report,
                and dashboard pages. The layout structure starts with an object
                called “cells”. The “cells” object contains the “rows” (vertical
                position) and “order” (horizontal position) and width of the
                “cards”. The cell width uses the bootstrap CSS width standard.
                The bootstrap CSS with standard is “col-md-” followed by a
                number between 1 and 12. These represent 1 to 12 of the screen
                width divided by 12.
              </p>
              <p>
                For example, if you want to have two cells that take up half the
                horizontal width each, you would make both the width “col-md-6
                darkCol” (12 divided by 2). If you wanted three same sized
                cells, you would use “col-md-4” (12 divided by 3). If you wanted
                the screen to be two-thirds the first cell and one third the
                second cell, the first cell would have “col-md-8” and the second
                cell would have “col-md-4”.
              </p>
              <p>
                Cards can be thought of like the outside of the component
                containers. By default, they will be white rectangles with
                rounded corners. Inside cards, you have containers. Containers
                allow you to divide a card horizontally and contain the
                components for that layout.
              </p>
              <p>
                Components vary from record pages, search pages, dashboards, and
                reports. For more details, view the compatibility table in each
                component page found in this documentation.
              </p>
              <p>
                The example shows a basic layout structure, and the table below
                shows the different properties for different layout objects.
              </p>
              <h3>Cells</h3>
              <table>
                <tbody>
                  <tr>
                    <td className="b top">Property</td>
                    <td className="b top">Description</td>
                  </tr>
                  <tr>
                    <td className="b">row</td>
                    <td>The vertical row for this cell.</td>
                  </tr>
                  <tr>
                    <td className="b">order</td>
                    <td>The order cells will be displayed.</td>
                  </tr>
                  <tr>
                    <td className="b">width</td>
                    <td>Bootstrap CSS width.</td>
                  </tr>
                  <tr>
                    <td className="b">hide</td>
                    <td>
                      Shows or hides the layout cell. <br />
                      <i>true, false default is false</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">hide_if_eval</td>
                    <td>
                      Dynamically show or hide the layout cell. This can be used
                      in conjunction with the tab menu.
                      <br />
                      <i>"(NL.Interface.tabMenu.value !== 'MyTabMenuValue')"</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">cards</td>
                    <td>
                      Cards of the white raised boxes at which containers and
                      components live.
                    </td>
                  </tr>
                </tbody>
              </table>
              <h3>Cards</h3>
              <table>
                <tbody>
                  <tr>
                    <td className="b top">Property</td>
                    <td className="b top">Description</td>
                  </tr>
                  <tr>
                    <td className="b">order</td>
                    <td>
                      The order the cards will be displayed on the screen.
                    </td>
                  </tr>
                  <tr>
                    <td className="b">max_height</td>
                    <td>
                      The maximum height in pixels as number or percentage as
                      string (200, "50%")
                    </td>
                  </tr>
                  <tr>
                    <td className="b">min_height</td>
                    <td>
                      The minimum height in pixels as number or percentage as
                      string (200, "50%")
                    </td>
                  </tr>
                  <tr>
                    <td className="b">title_icon</td>
                    <td>
                      Icon that will be displayed in the over layed title box a
                      the top of a card. Icons can be choosing from the material
                      icon font.
                    </td>
                  </tr>
                  <tr>
                    <td className="b">title_forecolor</td>
                    <td>
                      Foreground or text colour for the title box at the top of
                      a card.
                    </td>
                  </tr>
                  <tr>
                    <td className="b">title_backcolor</td>
                    <td>
                      Background colour for the title box at the top of a card.
                    </td>
                  </tr>
                  <tr>
                    <td className="b">containers</td>
                    <td>
                      Containers are the invisible vertical spaces for inserting
                      components.
                    </td>
                  </tr>
                </tbody>
              </table>
              <h3>Containers</h3>
              <table>
                <tbody>
                  <tr>
                    <td className="b top">Property</td>
                    <td className="b top">Description</td>
                  </tr>
                  <tr>
                    <td className="b">width</td>
                    <td>Bootstrap CSS width.</td>
                  </tr>
                  <tr>
                    <td className="b">order</td>
                    <td>The order containers will be displayed.</td>
                  </tr>
                  <tr>
                    <td className="b">components</td>
                    <td>
                      List of components that the user will interact with either
                      displaying or editing data. Components will be covered
                      under record, search, report, and dashboard components
                      sections of this documentation.
                    </td>
                  </tr>
                </tbody>
              </table>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Layout Example</h2>
            </section>
            <section>
              <h3>Example:</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"tab_menu"</span>: &#123; ... &#125;,
                </div>
                <div className="i1"></div>
                <div className="i1">
                  <span className="jsonG">"cells"</span>: &#123;
                </div>
                <div className="i2">
                  <span className="jsonG">
                    "<strong>my_first_cell</strong>"
                  </span>
                  : &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"row"</span>:{" "}
                  <span className="jsonP">1</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">1</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"width"</span>:{" "}
                  <span className="jsonY">"col-md-8"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"cards"</span>: &#123;
                </div>
                <div className="i4">
                  <span className="jsonG">
                    "<strong>my_first_card</strong>"
                  </span>
                  : &#123;
                </div>
                <div className="i5">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">1</span>,
                </div>
                <div className="i5">
                  <span className="jsonG">"min_height"</span>:{" "}
                  <span className="jsonP">400</span>,
                </div>
                <div className="i5">
                  <span className="jsonG">"title_text"</span>:{" "}
                  <span className="jsonY">"Incident"</span>,
                </div>
                <div className="i5">
                  <span className="jsonG">"title_icon"</span>:{" "}
                  <span className="jsonY">"headset_mic"</span>,
                </div>
                <div className="i5">
                  <span className="jsonG">"title_forecolor"</span>:{" "}
                  <span className="jsonY">"#ffffff"</span>,
                </div>
                <div className="i5">
                  <span className="jsonG">"title_backcolor"</span>:{" "}
                  <span className="jsonY">"#1E88E5"</span>,
                </div>
                <div className="i5">
                  <span className="jsonG">"containers"</span>: &#123;
                </div>
                <div className="i6">
                  <span className="jsonG">
                    "<strong>my_first_container</strong>"
                  </span>
                  : &#123;
                </div>
                <div className="i7">
                  <span className="jsonG">"width"</span>:{" "}
                  <span className="jsonY">"col-md-4"</span>,
                </div>
                <div className="i7">
                  <span className="jsonG">"components"</span>: &#123;{" "}
                </div>
                <div className="i8">
                  <span className="jsonG">
                    "<strong>my_first_component</strong>"
                  </span>
                  : &#123; ... &#125;,
                </div>
                <div className="i8">
                  <span className="jsonG">
                    "<strong>my_second_component</strong>"
                  </span>
                  : &#123; ... &#125;
                </div>
                <div className="i7">&#125; </div>
                <div className="i6">&#125;,</div>
                <div className="i6">
                  <span className="jsonG">
                    "<strong>my_second_container</strong>"
                  </span>
                  : &#123;
                </div>
                <div className="i7">
                  <span className="jsonG">"width"</span>:{" "}
                  <span className="jsonY">"col-md-8"</span>,
                </div>
                <div className="i7">
                  <span className="jsonG">"components"</span>: &#123;{" "}
                </div>
                <div className="i8">
                  <span className="jsonG">
                    "<strong>my_third_component</strong>"
                  </span>
                  : &#123; ... &#125;,
                </div>
                <div className="i8">
                  <span className="jsonG">
                    "<strong>my_forth_component</strong>"
                  </span>
                  : &#123; ... &#125;
                </div>
                <div className="i7">&#125; </div>
                <div className="i6">&#125;</div>
                <div className="i5">&#125;</div>
                <div className="i4">&#125;</div>
                <div className="i3">&#125;</div>
                <div className="i2">&#125;</div>
                <div className="i1">&#125;</div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Layout_structure;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Layout_structure.js